import { InjectionToken } from '@angular/core';
import { ILoggerConfig } from './logger-config.model';

export const LoggerConfig: InjectionToken<ILoggerConfig> = new InjectionToken('LoggerConfig');




// WEBPACK FOOTER //
// C:/Users/user/projects/ansyn/src/app/packages/core/models/logger.config.ts